(function () {
  'use strict';

  function activateTab(root, nextTab, focusTab) {
    var tabs = Array.from(root.querySelectorAll('[data-showcase-tab]'));
    var panels = Array.from(root.querySelectorAll('[data-showcase-panel]'));
    var targetId = nextTab.dataset.target;

    tabs.forEach(function (tab) {
      var isActive = tab === nextTab;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.tabIndex = isActive ? 0 : -1;
    });

    panels.forEach(function (panel) {
      var isActive = panel.id === targetId;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });

    if (focusTab) nextTab.focus();
  }

  function initShowcase(root) {
    if (root.dataset.productShowcaseReady === 'true') return;
    root.dataset.productShowcaseReady = 'true';

    var tabs = Array.from(root.querySelectorAll('[data-showcase-tab]'));
    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activateTab(root, tab, false);
      });

      tab.addEventListener('keydown', function (event) {
        var nextIndex = null;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === null) return;

        event.preventDefault();
        activateTab(root, tabs[nextIndex], true);
      });
    });

    root.querySelectorAll('[data-showcase-view-more]').forEach(function (button) {
      button.addEventListener('click', function () {
        var panel = button.closest('[data-showcase-panel]');
        if (!panel) return;

        panel.querySelectorAll('.kik-product-showcase__card--extra').forEach(function (card) {
          card.hidden = false;
        });
        button.setAttribute('aria-expanded', 'true');
        button.parentElement.hidden = true;
      });
    });
  }

  function initAll(scope) {
    var context = scope || document;
    if (context.matches && context.matches('[data-product-showcase]')) initShowcase(context);
    context.querySelectorAll('[data-product-showcase]').forEach(initShowcase);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var panel = event.target.matches('[data-showcase-panel]')
      ? event.target
      : event.target.querySelector('[data-showcase-panel]');
    if (!panel) return;

    var root = panel.closest('[data-product-showcase]');
    var tab = root && root.querySelector('[data-target="' + panel.id + '"]');
    if (root && tab) activateTab(root, tab, false);
  });
})();
